import { useIsMerchantSwitching } from '~/composables/useMerchantSwitch';

export default defineNuxtPlugin({
	name: 'merchant-switch',
	setup: () => {
		const router = useRouter();
		const isSwitching = useIsMerchantSwitching();

		const release = () => {
			isSwitching.value = false;
		};

		router.afterEach(release);

		router.onError(release);
	},
});
